import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CarFormFields } from "web_myplann/Portfolio/Forms/CarForm/CarFormFields";
import { useCreateCarForm } from "web_myplann/Portfolio/Forms/CarForm/useCreateCarForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateCarForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateCarForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<CarFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
